import uiI18n from "../i18n";
import React from "react";
import {
  FaHome,
  FaShoppingCart,
  FaKey,
  FaUmbrellaBeach,
  FaSearchLocation,
  FaPlus,
  FaChevronDown,
} from "react-icons/fa";
import { BiSolidOffer } from "react-icons/bi";
import { LuSearch } from "react-icons/lu";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HeaderMobileMenu({
  toggleMenu,
  handleMenuItemClick,
  addAdMenuOpen,
  setAddAdMenuOpen,
  handleCreateAdClick,
  menuRef,
  phoneMode,
}) {
  const { t } = useTranslation();
  const location = useLocation();

  const menuItems = [
    {
      name: t("home"),
      icon: FaHome,
      path: "/",
    },
    {
      name: t("buy"),
      icon: FaShoppingCart,
      path: "/Category/sale",
    },
    {
      name: t("rent"),
      icon: FaKey,
      path: "/Category/rent",
    },
    {
      name: t("vacances"),
      icon: FaUmbrellaBeach,
      path: "/Vacation",
    },
    {
      name: t("offers"),
      icon: BiSolidOffer,
      path: "/offers",
    },
    {
      name: t("propertyRequest.nav.public"),
      icon: FaSearchLocation,
      path: "/property-requests",
      badge: t("propertyRequest.nav.new"),
    },
  ];

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }

    return location.pathname
      .toLowerCase()
      .startsWith(path.toLowerCase());
  };

  const handleNavigation = (path) => {
    handleMenuItemClick(path);

  };

  if (phoneMode === "publish") return (
    <aside ref={menuRef} id="lina-mobile-menu" className="lina-mobile-panel phone-publish-panel" aria-label={t("phoneNav.publish")}>
      <div className="phone-panel-heading"><h2>{t("phoneNav.publish")}</h2><button type="button" onClick={toggleMenu} aria-label={t("close")}>&times;</button></div>
      <div className="phone-publish-choices">
        <button type="button" onClick={() => handleCreateAdClick("/CreateBien")}><FaPlus aria-hidden="true" /><span>{t("add_ad")}<small>{t("mobileFinal.longStay")}</small></span></button>
        <button type="button" onClick={() => handleCreateAdClick("/CreateVacation")}><FaUmbrellaBeach aria-hidden="true" /><span>{t("mobileFinal.publishVacation")}<small>{t("mobileFinal.shortStay")}</small></span></button>
        <button type="button" onClick={() => handleNavigation("/property-request/new")}><LuSearch aria-hidden="true" /><span>{t("propertyRequest.home.start")}</span></button>
      </div>
    </aside>
  );
  return (
    <aside
      ref={menuRef}
      id="lina-mobile-menu"
      aria-label={uiI18n.t("ui.mobile_menu")}
      className="lina-mobile-panel fixed start-0 end-0 z-50 overflow-y-auto border-t border-slate-100 bg-white px-4 pt-4 shadow-2xl"
    >
      {phoneMode && <div className="phone-panel-heading"><h2>{t("phoneNav.menu")}</h2><button type="button" onClick={toggleMenu} aria-label={t("close")}>&times;</button></div>}
      {/* Ajouter une annonce (en haut ; le cadre n'apparaît qu'avec le menu déroulant ouvert) */}
      <div className={addAdMenuOpen ? "rounded-2xl border border-slate-100 bg-slate-50 p-2" : ""}>
        <button
          type="button"
          onClick={() =>
            setAddAdMenuOpen(
              (previousValue) => !previousValue
            )
          }
          aria-expanded={addAdMenuOpen}
          className="
            flex
            w-full
            items-center
            justify-between
            rounded-xl
            bg-green-700
            px-4
            py-3.5
            text-sm
            font-bold
            text-white
            shadow-md
            transition
            [@media(hover:hover)]:hover:bg-green-800
          "
        >
          <span className="flex items-center gap-2">
            <FaPlus size={12} />
            {t("add_ad")}
          </span>

          <FaChevronDown
            size={12}
            className={`transition-transform duration-200 ${
              addAdMenuOpen ? "rotate-180" : ""
            }`}
          />
        </button>

        {addAdMenuOpen && (
          <div className="mt-2 space-y-2">
            <button
              type="button"
              onClick={() =>
                handleCreateAdClick("/CreateBien")
              }
              className="
                flex
                w-full
                items-center
                gap-3
                rounded-xl
                bg-white
                px-4
                py-3
                text-start
                transition
                [@media(hover:hover)]:hover:bg-green-50
              "
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-green-50 text-xl">
                🏠
              </span>

              <span>
                <span className="block text-sm font-bold text-slate-900">
                  {t("create_ad")}
                </span>

                <span className="mt-0.5 block text-xs text-slate-500"> {uiI18n.t("ui.sale_or_long_term_rental")} </span>
              </span>
            </button>

            <button
              type="button"
              onClick={() =>
                handleCreateAdClick(
                  "/CreateVacation"
                )
              }
              className="
                flex
                w-full
                items-center
                gap-3
                rounded-xl
                bg-white
                px-4
                py-3
                text-start
                transition
                [@media(hover:hover)]:hover:bg-sky-50
              "
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-sky-50 text-xl">
                🏖️
              </span>

              <span>
                <span className="block text-sm font-bold text-slate-900">
                  {t("create_adW")}
                </span>

                <span className="mt-0.5 block text-xs text-slate-500"> {uiI18n.t("ui.daily_or_holiday_rental")} </span>
              </span>
            </button>
          </div>
        )}
      </div>

      {/* Je recherche un bien : publier une demande de recherche */}
      <button
        type="button"
        onClick={() => handleNavigation("/property-request/new")}
        aria-describedby="lina-mobile-request-hint"
        className="mt-2 flex w-full items-center justify-center gap-2 rounded-xl border-2 border-green-700 bg-white px-4 py-3 text-sm font-bold text-green-800 transition [@media(hover:hover)]:hover:bg-green-50"
      >
        <LuSearch size={16} aria-hidden="true" />
        {t("propertyRequest.home.start")}
      </button>
      {/* Distingue cette demande de "Rechercher une annonce" (texte existant, 2 lignes au plus). */}
      <p id="lina-mobile-request-hint" className="mb-4 mt-1.5 line-clamp-2 px-2 text-center text-xs leading-snug text-slate-500">
        {t("propertyRequest.home.lead")}
      </p>

      {/* Navigation */}
      <nav aria-label={uiI18n.t("ui.mobile_navigation")}>
        <div className="space-y-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);

            return (
              <button
                key={item.path}
                type="button"
                onClick={() => handleNavigation(item.path)}
                className={`
                  flex
                  w-full
                  items-center
                  gap-3
                  rounded-2xl
                  px-4
                  py-1.5
                  text-start
                  text-sm
                  font-semibold
                  transition
                  ${
                    active
                      ? "bg-green-50 text-green-700"
                      : "text-slate-700 [@media(hover:hover)]:hover:bg-slate-100 [@media(hover:hover)]:hover:text-slate-950"
                  }
                `}
              >
                <span
                  className={`
                    flex
                    h-10
                    w-10
                    shrink-0
                    items-center
                    justify-center
                    rounded-xl
                    ${
                      active
                        ? "bg-green-100 text-green-600"
                        : "bg-slate-100 text-slate-500"
                    }
                  `}
                >
                  <Icon size={16} />
                </span>

                <span className="flex min-w-0 flex-1 flex-wrap items-center gap-2">
                  <span>{item.name}</span>{" "}
                  {item.badge && (
                    <span className="rounded-full bg-green-700 px-2 py-0.5 text-xs font-bold text-white">
                      {item.badge}
                    </span>
                  )}
                </span>

                {active && (
                  <span className="h-2 w-2 rounded-full bg-green-600" />
                )}
              </button>
            );
          })}
        </div>
      </nav>

      {/* Séparateur */}
      <div className="my-4 h-px bg-slate-100" />

      {/* Rechercher une annonce (messages, favoris et compte : header ; historiques : menu compte). */}
      <button type="button" onClick={() => handleNavigation("/category/all")}
        className="flex w-full items-center gap-3 rounded-2xl px-4 py-1.5 text-start text-sm font-semibold text-slate-700 transition [@media(hover:hover)]:hover:bg-slate-100 [@media(hover:hover)]:hover:text-slate-950">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
          <LuSearch size={16} />
        </span>
        <span className="flex-1">{t("mobile.search")}</span>
      </button>

      {/* Bouton de fermeture */}
      <button
        type="button"
        onClick={toggleMenu}
        className="
          mt-5
          w-full
          rounded-xl
          border
          border-slate-200
          px-4
          py-3
          text-sm
          font-semibold
          text-slate-600
          transition
          [@media(hover:hover)]:hover:bg-slate-100
          [@media(hover:hover)]:hover:text-slate-900
        "
      >
        {t("close") || uiI18n.t("ui.close_menu")}
      </button>
    </aside>
  );
}
